import { IChooseItems } from '../../../../components/mainContent/TableAllDishes'
import { IEdgeServers } from '../../../../core/api/dto/BuffetDishDto'
import React, { useState } from 'react'
import {
  AppNotification,
  NotificationType,
} from '../../../../components/notification/Notification'
import { useTranslation } from 'react-i18next'
import {
  useDeleteTagsToFotoboxesMutation,
  useSendTagsToFotoboxesMutation,
} from '../../../../core/api/TagsApi'
import { ITag } from '../../../../core/api/dto/TagsDto'
import { uniqFilter } from '../../DishesPage/hooks/useSentOnFotobox'

interface UseSentTagsOnFotoboxProps {
  chooseItems: IChooseItems | null
  tableData: ITag[]
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>
}

interface UseSentTagsOnFotoboxResponse {
  isDeleteMode: boolean
  deleteStations: IEdgeServers[] | null
  sentPopup: boolean
  closeSentPopup: () => void
  openDeleteStationPopup: () => void
  openSentPopup: () => void
  onSendTags: (value: string[]) => void
  onDeleteTagsStation: (value: string[]) => void
  isLoadingSend: boolean
}

export const useSentTagsOnFotobox = ({
  tableData,
  chooseItems,
  setChooseItems,
}: UseSentTagsOnFotoboxProps): UseSentTagsOnFotoboxResponse => {
  const { t } = useTranslation()
  const [sentPopup, setSentPopup] = useState(false)
  const [isDeleteMode, setIsDeleteMode] = useState(false)
  const [deleteStations, setDeleteStations] = useState<IEdgeServers[] | null>(
    null,
  )

  const [sendTagsToFotoboxes, { isLoading: isLoadingSend }] =
    useSendTagsToFotoboxesMutation()
  const [deleteTagsToFotoboxes] = useDeleteTagsToFotoboxesMutation()

  const chooseTags = tableData
    .filter((item) => chooseItems && chooseItems[item.id] && !item.archived)
    .map((item) => item.guid)

  const closeSentPopup = () => {
    setSentPopup(false)
    setIsDeleteMode(false)
    setDeleteStations(null)
  }
  const openDeleteStationPopup = () => {
    setSentPopup(true)
    setIsDeleteMode(true)
    const deleteStation = uniqFilter(
      tableData
        .filter((item) => chooseItems && chooseItems[item.id] && !item.archived)
        .map((item) => item.edgeServers)
        .flat(1),
    )
    setDeleteStations(deleteStation)
  }
  const openSentPopup = () => setSentPopup(true)

  const onSendTags = (value: string[]) => {
    if (value.length && chooseTags.length) {
      sendTagsToFotoboxes({
        tagsGuids: chooseTags,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('Тэги успешно отправлены на выбранные станции'),
          })
          setChooseItems(null)
          setSentPopup(false)
        })
    }
  }
  const onDeleteTagsStation = (value: string[]) => {
    if (value.length && chooseTags.length) {
      deleteTagsToFotoboxes({
        tagsGuids: chooseTags,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('Тэги успешно удалены с выбранных станций'),
          })
          setChooseItems(null)
          setSentPopup(false)
          setIsDeleteMode(false)
          setDeleteStations(null)
        })
    }
  }

  return {
    isDeleteMode,
    deleteStations,
    sentPopup,
    closeSentPopup,
    openSentPopup,
    openDeleteStationPopup,
    onDeleteTagsStation,
    onSendTags,
    isLoadingSend,
  }
}
